import script from "./MultifileElement.vue?vue&type=script&lang=js"
export * from "./MultifileElement.vue?vue&type=script&lang=js"

import "./MultifileElement.vue?vue&type=style&index=0&id=7706f1fc&lang=scss"

const __exports__ = script;

export default __exports__